import { useMutation } from "@apollo/client";
import { SEND_UNREAD_COMPANY_DOCUMENT_NOTIFICATION } from "../api/send-unread-company-document-notification";
import { useDocumentsTranslations } from "@/modules/documents/shared/utils/use-documents-translations";
import { useNotification } from "@/shared/feedback/notification";

export function useSendUnreadCompanyDocumentNotificationMutation() {
  const t = useDocumentsTranslations();
  const notify = useNotification();
  const [sendNotification, { loading }] = useMutation(
    SEND_UNREAD_COMPANY_DOCUMENT_NOTIFICATION,
  );

  const send = async (documentId: string, personIds?: string[]) => {
    const response = await sendNotification({
      variables: {
        documentId,
        personIds,
      },
    });

    if (response.data?.sendUnreadCompanyDocumentNotification) {
      notify?.success({
        message: t("Notification sent"),
      });
    }
  };

  return {
    send,
    loading,
  };
}
